module.exports = __webpack_public_path__ + "img/lg4.a771f92d.jpg";